<template>
  <v-app class="test">
    <v-content class="bg">
      <v-container>
        <v-card
          class="mx-auto pa-2 mb-4 text-center"
          flat
          max-width="500"
        >
          <v-form
            class="my-6"
            ref="form"
            @submit.prevent="submit"
          >
            <v-text-field
              label="Enter an URL"
              v-model="url"
              required
              outlined
              :rules="[rules.required, rules.url]"
            />

            <div class="d-flex justify-center align-items-center">
              <v-btn
                color="primary"
                type="submit"
                class="mr-2"
              >
                Get Headings
              </v-btn>
            </div>
          </v-form>
        </v-card>

        <ErrorAlert
          :error="error"
        />

        <div v-if="result">
          <v-row class="justify-center">
            <v-col
              cols="12"
              sm="4"
            >
              <TileComponent
                title="H1 count"
                :text=" result.h1.length"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <TileComponent
                title="H2 count"
                :text=" result.h2.length"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <TileComponent
                title="H3 count"
                :text=" result.h3.length"
              />
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col
              cols="12"
              sm="4"
            >
              <TileComponent
                title="H4 count"
                :text=" result.h4.length"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <TileComponent
                title="H5 count"
                :text=" result.h5.length"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <TileComponent
                title="H6 count"
                :text=" result.h6.length"
              />
            </v-col>
          </v-row>

          <v-row class="mt-10">
            <v-col
              cols="12"
              sm="6"
            >
              <h3 class="mb-4">
                Headings Tags
              </h3>
              <div
                v-for="(list, i) in notEmplyLists"
                :key="i+1"
                class="rounded-lg light-stroke-border my-4 h-list"
              >
                <ListItemWithChip
                  v-for="h in list"
                  :key="h"
                  :prefix="`h${i+1}`"
                  prefix-color="primary"
                >
                  {{ h }}
                </ListItemWithChip>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <div class="d-flex flex-row justify-space-between">
                <h3 class="mb-4">
                Table of Content
                </h3>
                <v-btn
                  @click="exportToCSV"
                  color="primary"
                  class="mb-4"
                  small
                  outlined
                >
                  Download CSV
                </v-btn>
              </div>
              <OutlineView
                :h1="result.h1[0]"
                :toc="result.toc"
                open-all
              />
            </v-col>
          </v-row>
        </div>
      </v-container>

      <LoadingOverlay v-if="loading" />
    </v-content>
  </v-app>
</template>

<script>
import { saveAs } from 'file-saver'
import validationRules from '../validation-rules.js'
import { extractHeadings } from '../services/api'
import ErrorAlert from '@/components/ErrorAlert.vue'

import LoadingOverlay from '@/components/LoadingOverlay.vue'
import ListItemWithChip from '@/components/ListItemWithChip.vue'
import OutlineView from '@/components/compare-urls/OutlineView.vue'
import TileComponent from '@/components/TileComponent.vue'

function flattenTOC(nodes) {
  const result = [];

  function processNode(node) {
    result.push({ tag: node.tag, name: node.name });
    if (node.children && node.children.length > 0) {
      node.children.forEach(processNode);
    }
  }

  nodes.forEach(processNode);
  return result;
}

export default {
  name: 'ExtractHeadings',
  components: {
    ErrorAlert,
    LoadingOverlay,
    ListItemWithChip,
    OutlineView,
    TileComponent,
  },
  data: () => ({
    loading: false,
    url: null,
    result: null,
    error: null,
    rules: validationRules,
  }),
  computed: {
    notEmplyLists () {
      return [
        this.result.h1,
        this.result.h2,
        this.result.h3,
        this.result.h4,
        this.result.h5,
        this.result.h6,
      ].filter(a => a.length)
    }
  },
  methods: {
    async submit() {
      this.error = null
      this.result = null

      if (this.$refs.form.validate()) {
        // this.loading = true

        try {
          const { data } = await extractHeadings({ url: this.url })
          this.result = data
        } catch (error) {
          this.error = error
        } finally {
          this.loading = false
        }
      }
    },
    exportToCSV() {
      if (!this.result) return

      if (!this.result.toc.length) return

      const simplifiedTOC = flattenTOC(this.result.toc)
      const headers = ["Tag", "Content"];

      const h1 = this.result.h1[0]
      const rows = simplifiedTOC.map(row => [row.tag, row.name])
      rows.unshift(['h1', h1]);

      console.log(h1)

      console.log(rows)

      const csvContent = [
        headers.join(","),    // Headers
        ...rows.map(row => row.join(","))  // Data rows
      ].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
      saveAs(blob, "toc.csv")
    }
  },
}
</script>

<style scoped>
.light-stroke-border {
  border: 1px solid var(--v-stroke-lighten1);
}

.h-list > div:last-child >>> .list-item__content {
  border: 0;
}
</style>

<style>
.v-application--wrap {
  min-height: auto;
}
</style>